import React, { useEffect, useState } from "react";
import Select from "react-select";
import { FormControl, Button as MButton } from "@mui/material"; // Import MUI Button
import { s360ConfigService } from "../../../Services/S360Config";

export default function NCXDropDown({ listData, sendMessageToPreview, id }) {
  

  const { buttonText, data, disabled } = listData;
  const [parsedOptions, setParsedOptions] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null); // State to track selected option
  const [disableonSubmit, setDisableOnSubmit] = useState(disabled);

  // Use effect to parse the list data into options
  useEffect(() => {
    if (data.length !== 0) {
      // Restructuring data into proper format for the dropdown
      const tempOptions = data.map((oneOption) => ({
        value: oneOption.value || "", // Use the value field
        label: oneOption.text, // Use text field for display
        componentId: oneOption.componentId, // Keep componentId for tracking
      }));
      setParsedOptions(tempOptions); // Set parsed options to state
    }
    
  }, [data, selectedOption]);

  const selectOptionsStyle = {
    control: (provided) => ({
      ...provided,
      boxShadow: "none",
      borderStyle: "unset",
      paddingBottom: "0px",
      width: "70vw !important", // Ensure full width
      overflowY: "visible !important",
      border: "1px solid #d0d0d0", // Add your border style
      paddingLeft: "10px", // Add left padding
      marginLeft: "-8px", // Add margin to the left
      ...s360ConfigService.config?.customDesign?.initialFormSelectControl,
    }),
    singleValue: (provided) => ({
      ...provided,
      fontSize: "13px",
      fontWeight: "bold",
      fontFamily: "lato",
      ...s360ConfigService.config?.customDesign?.initialFormSelectSingleValue,
    }),
    valueContainer: (provided) => ({
      ...provided,
      overflow: "hidden",
      paddingLeft: "0px",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    menuList: (base) => ({ ...base, paddingBottom: "0px" }),
    indicatorsContainer: (provided) => ({
      ...provided,
      svg: {
        fill: s360ConfigService.config?.configDetails?.primaryFontColor ?? "black",
        paddingBottom: "1px",
      },
    }),
    menu: (provided) => ({
      ...provided,
      zIndex: 9999,
      overflowY: "visible !important",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#AAAAAA",
      fontSize: "12px",
      fontFamily: "lato",
      fontWeight: "500",
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => {
      const color =
        s360ConfigService.config?.customDesign?.initialFormSelectBackground
          ?.color;
      return {
        ...styles,
        backgroundColor: isDisabled
          ? null
          : isSelected
          ? '#9c9c9c'
          : isFocused
          ? s360ConfigService.config?.configDetails?.primaryFontColor
          : '#9c9c9c',
        ":active": {
          ...styles[":active"],
          backgroundColor: null,
        },
        color: s360ConfigService.config?.configDetails?.primaryColor,
        borderBottom: "1px solid #ccc",
        ...s360ConfigService.config?.customDesign?.initialFormSelectBackground,
      };
    },
  };

  // Function to handle select change
  const handleSelectChange = (selected) => {
    // Update selected option state with the entire object (value, label, componentId)
    setSelectedOption(selected);
  };

  // Function to handle submit button click
  const handleSubmit = () => {
    if (selectedOption) {
      // Ensure you pass both value and componentId to the sendMessageToPreview function
      sendMessageToPreview(selectedOption.label, selectedOption.componentId);
      setDisableOnSubmit(true);
    }
  };

  return (
    <div className="dropDownContainer" key={`${id}-dropdowncontainer`}>
      <Select
          className="s360-initial-form-select"
          styles={selectOptionsStyle}
          maxMenuHeight={198}
          menuPortalTarget={document.body}
          options={parsedOptions} // Use parsed options for the dropdown
          captureMenuScroll={false}
          isSearchable={false}
          value={selectedOption} // Bind the selected option
          onChange={handleSelectChange} // Handle the change
          components={{ IndicatorSeparator: () => null }}
          key={`${id}-dropdownselect`}
          isDisabled={disableonSubmit}
      />

      {/* Add the submit button below the dropdown */}
      <MButton
        onClick={handleSubmit}
        variant="contained"
        sx={{
          backgroundColor: `${s360ConfigService.config?.configDetails?.primaryColor ?? '#fff'} !important`, // Background color should be white or transparent
          color: `${s360ConfigService.config?.configDetails?.primaryFontColor ?? '#000'} !important`,
          width: '100px !important',
          borderRadius: "30px !important",
          border: "2px solid #d9d9d9 !important", // Light grey border
          margin: "10px", // Margin to create space between buttons
          marginLeft: '0px !important',
          padding: "10px",
          fontSize: "12px", // Adjust text size
          fontFamily: "'Lato', sans-serif",
          textAlign: "center",
          cursor: "pointer",
          textTransform: "capitalize",
          transition: "background-color 0.3s ease-in-out, color 0.3s",
          boxShadow: 'none',
          "&:hover": {
              backgroundColor: "#f2f2f2", // Slight change on hover
              border: "2px solid #b3b3b3 !important",
              boxShadow: 'none',
          },
          "&:disabled": {
              backgroundColor: "#fff !important",
              color: "#b3b3b3", // Change text color when disabled
              borderColor: "#e0e0e0", // Light grey border when disabled
              opacity: "0.2 !important", // Reduce opacity when disabled
          },
        }}
        key={`${id}-dropdownsubmitbutton`}
        disabled={disableonSubmit}
      >
        Submit
      </MButton>
    </div>
  );
}
